import { render, staticRenderFns } from "./DisplayInfoTitleShow.vue?vue&type=template&id=7d80b7bc&scoped=true"
import script from "./DisplayInfoTitleShow.vue?vue&type=script&lang=js"
export * from "./DisplayInfoTitleShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d80b7bc",
  null
  
)

export default component.exports